import { render, staticRenderFns } from "./CustomizeItem.vue?vue&type=template&id=79079548&"
import script from "./CustomizeItem.vue?vue&type=script&lang=js&"
export * from "./CustomizeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports